<ion-grid>
  <ion-row class="ion-justify-content-end ion-align-items-center margin-bottom-l">
    <ion-button class="close-button" color="getm-background-light-blue" (click)="onDismiss()" fill="solid"
      shape="round">
      <ion-icon name="getm-close" class="close-icon" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-row>
  <ion-row class="margin-bottom-l">
    <ion-col class="ion-text-center ion-no-padding ticket-image" size="12">
      <ion-img [src]="'Icons.discount-ticket' | translate" alt="Ticket discount"></ion-img>
    </ion-col>
  </ion-row>
  <ion-row class="margin-bottom-s">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="max-discounts-title">
        {{ 'Modals.max-discounts-limit.title' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row class="margin-bottom-l">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="max-discounts-subtitle">
        {{ 'Modals.max-discounts-limit.subtitle' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row class="margin-bottom-xxl">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="max-discounts-body">
        {{ 'Modals.max-discounts-limit.text' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row class="margin-bottom-xxl">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="max-discounts-body">
        {{ 'Modals.max-discounts-limit.question' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row style="flex-wrap: nowrap;" class="gap-s">
    <ion-col class="ion-no-padding" size="6">
      <getm-button [text]="'Modals.max-discounts-limit.cancelButton' | translate" color="tertiary" size="large" expand="block" (click)="onDismiss()"></getm-button>
    </ion-col>
    <ion-col class="ion-no-padding" size="6">
      <getm-button [text]="'Modals.max-discounts-limit.confirmButton' | translate" color="primary" size="large" expand="block" (click)="onConfirm()"></getm-button>
    </ion-col>
  </ion-row>
</ion-grid>
